<template>
  <div id="header">
    <img id="back" src="../../assets/back_white.png" @click="back">
    <span style="flex: 1"></span>
    <p class="btn_login" @click="login" v-if="!this.$store.state.token"></p>
    <div class="btn_user" v-if="this.$store.state.token">
      <img src="@/assets/header_default.png"/>
      <p>{{ indexData ? indexData.data.username : '' }}</p>
    </div>

    <div id="info_cash">
      <img src="../../assets/coins.png">
      <p id="btn_amount">$ {{ indexData ? indexData.data.showBalance.toFixed(2) : '' }}</p>
      <div id="btn_withdraw_contain" @click="withdraw">
        <p id="btn_withdraw"></p>
      </div>
    </div>
    <img id="btn_service" src="../../assets/servicers.png" @click="goServiceWeb">
  </div>
</template>
<script>

import http from '@/utils/http'
import { mapState } from 'vuex'
import bus from 'vue3-eventbus'

export default {
  props: {
    indexData: Object
  },
  computed: {
    ...mapState(['pn', 'channel', 'pkg']),
    showBalance () {
      if (!this.$props.indexData) {
        return ''
      } else {
        const jsonObj = JSON.parse(this.$props.indexData)
        return jsonObj.data.showBalance.toFixed(2)
      }
    }
  },
  methods: {
    back () {
      window.parent.postMessage(JSON.stringify({
        action: 'close',
        data: {
          title: 'close',
          iframeId: 'share-iframe'
        }
      }), '*')
      if (window.closePage) {
        window.closePage.closePage();
      }
    },
    login () {
      this.$store.commit('showLogin', true)
    },
    goServiceWeb () {
      this.$router.push({
        path: '/web',
        query: { url: http.baseH5Url + '/customer_h5?channel=' + this.channel },
        param: { url: http.baseH5Url + '/customer_h5?channel=' + this.channel }
      })
    },
    showLevelDialog () {
      bus.emit('showLevelDialog', true)
    },
    withdraw () {
      if (!this.$store.state.token) {
        this.$router.push('/main/my_cash')
        return
      }
      if (window.matchMedia('(orientation: portrait)').matches) {
        this.$router.push({
          path: '/web',
          query: { url: http.baseH5Url + '/withdraw?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
          param: { url: http.baseH5Url + '/withdraw?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token }
        })
      } else if (window.matchMedia('(orientation: landscape)').matches) {
        this.$router.push({
          path: '/withdraw'
        })
      }
    }
  }
}
</script>

<style scoped>



@media screen and (orientation: portrait) {
  #header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vh;
    height: 8.3rem;
    display: flex;
    align-content: center;
    justify-content: center;
    background-image: url("../../assets/bg_title_bar.png");
    background-size: cover;
  }
}

@media screen and (orientation: landscape) {
  #header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 8.3rem;
    display: flex;
    align-content: center;
    justify-content: center;
    background-image: url("../../assets/bg_title_bar.png");
    background-size: cover;
  }
}

#back {
  margin-left: 5rem;
}

#header > :first-child {
  width: 5.7rem;
  height: 5.1rem;
  align-self: center;
}

#btn_level_icon {
  width: 5.3rem;
  height: 5.3rem;
  align-self: center;
  margin-left: 3rem;
  margin-right: 2rem;
}
#btn_level_icon:active {
  opacity: 0.6;
}
#btn_service {
  width: 5.3rem;
  height: 5.3rem;
  align-self: center;
  margin-right: 3rem;
}

#btn_service:active {
  opacity: 0.6;
}

.btn_login {
  display: flex;
  justify-self: center;
  justify-content: center;
  align-self: center;
  height: 5.4rem;
  width: 22.6rem;
  background-image: url("../../assets/iv_signup.png");
  background-size: cover;
}

.btn_login:active {
  opacity: 0.6;
}

.btn_user {
  justify-self: center;
  align-content: center;
  justify-content: center;
  align-self: center;
  position: relative;

  
  align-self: center;
  height: 5.4rem;
  min-width: 23rem;
  width: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  background-image: url("@/assets/bg_withdraw.png");
  box-sizing: border-box;
  align-items: center;
}

.btn_user > img {
  width: 5.4rem;
  height: 5.4rem;
  align-self: center;
  left: -1rem;
  top: auto;
  position: absolute;
}

.btn_user > p {
  font-size: 2.5rem;
  color: white;
  align-self: center
}

#info_cash {
  margin: 0 1.25rem 0 5rem;
  align-self: center;
  height: 5.4rem;
  min-width: 23rem;
  width: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  background-image: url("@/assets/bg_withdraw.png");
  box-sizing: border-box;
  align-items: center;
}

#info_cash > :first-child {
  margin-left: -1rem;
  margin-right: 2rem;
  height: 5.7rem;
  width: 5.4rem;
  align-self: center;
}

#btn_amount {
  color: #FBEB6E;
  font-size: 2.2rem;
  line-height: 4.6rem;
  margin-right: 1.6rem;
  font-weight: bolder;

}

#btn_withdraw_contain {
  width: 15.8rem;
  height: 5rem;
  align-self: center;
  display: flex;
  align-content: center;
  justify-content: center;
  background-image: url("../../assets/iv_withdraw.png");
  background-position: right;
  background-size: cover;

}

#btn_withdraw_contain:active {
  opacity: 0.6;
}

#btn_withdraw_contain > p {
  color: white;
  align-self: center;
  line-height: 4.6rem;
  font-weight: bolder;
  font-size: 2.2rem;
}

</style>
